import {createAsyncThunk} from '@reduxjs/toolkit'
import * as types from './types'
import {lookupSuccess, lookupFail} from './operations'
import digipayLocationService from 'app/modules/core/digipayLocationService'
import normalize from 'app/modules/core/normalize'

export const lookupRequest = createAsyncThunk(
  types.LOOKUP_REQUEST,
  async (_, { dispatch, getState }) => {
    const { address, distance } = getState().branchesData.lookupData
    digipayLocationService.post(`lookups/`, {address, distance})
      .then(response => {
        const lookupData = {
          ...response.data,
          locations: normalize(response.data.locations.map(location => ({
            ...location,
            coordinates: [location.coordinates.longitude, location.coordinates.latitude],
          })), 'name')
        }

        dispatch(lookupSuccess(lookupData))
      }).catch(error => {
        console.log(error)
        dispatch(lookupFail())
      })
  }
)